import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AdminNav from "../../Components/AdminNav.jsx/AdminNav";
import MenuFilter2 from "../../Components/MenuFilter/MenuFilter2";
import QueueRow from "../../Components/QueueRow/QueueRow.jsx";
import "./Orders.css";

const Orders = () => {
 const  [orders, setOrders] = useState([]);
 const  [ogOrders, setOGOrders] = useState([]);
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(true);
  const [bizCategories, setBizCategories] = useState([]);
  const [currentBizCategories, setCurrentBizCategories] = useState([]);
  // let x = axios.get("/ticket");

  useEffect(() => {
    initializeMenu();
    setInterval(() => {
    checkMenu()
    }, 10000);
    // eslint-disable-next-line
  }, []);

  const orderQueue = (list) => {
    let queue = list;
    queue.sort(function(a, b){
      return (a.data.created < b.data.created) ? -1 : ((a.data.created > b.data.created) ? 1 : 0)
  })
     let amountInQueue = queue.length;
     setAmount(amountInQueue)
     setOrders(queue);
     setOGOrders(queue);
     const categoriesSet = [
      ...new Set(
        queue.map((bizItem) => bizItem.data.category.toUpperCase())
      ),
    ];
    setBizCategories(categoriesSet);
    setCurrentBizCategories(categoriesSet);
    setLoading(false)
  }
  const initializeMenu = async () => {
    try {
      const response = await axios.get("/ticket");
     orderQueue(response.data)
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const checkMenu = async () => {
    try {
      const response = await axios.get("/ticket");
     if (response.data.length !== amount) {
      orderQueue(response.data)
     } else {
      setLoading(false);
     }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const filterBizByCategory = (category) => {
    if (category === "ALL") {
      setCurrentBizCategories(bizCategories);
      setOrders(ogOrders)
    } else {
      setCurrentBizCategories([category]);
      let queue = ogOrders;
      const queueFilter = queue.filter(item => item.data.category.toUpperCase() === category);
      setOrders(queueFilter)
    }
  };


  
  if(loading)return null;

  return (
    <>
      <AdminNav />
      <MenuFilter2
        menuCategories={bizCategories}
        handleClick={filterBizByCategory}
      />
      <div className="order-wrapper">
        <div className="row s12">
          <div className="col s4 center">
              <p className="queue-total">Total in Queue: <small className="submit-button total-num">{amount}</small></p>
          </div>
          <div className="order-padding col s4 center">
             <Link to={"/admin/completed"} > <button className=" btn submit-button queue-complete">Completed Orders</button>
               </Link>
          </div>
          <div className="order-padding col s4 center">
             <Link to={"/queue"} target="_blank" > <button className=" btn submit-button queue-complete">Display</button>
               </Link>
          </div>
        </div>
        <div className="order-table" >

        <table className="left">
          <thead>
            <tr>
            <th className="table-col">Ready?</th>
              <th className="table-col">Name</th>
              <th className="table-col">Service</th>
              <th className="table-col">Phone Number</th>
              <th className="table-col">Check-in</th>
              <th className="table-col">Elasped</th>
              <th className="table-col">Cancel</th>
            </tr>
          </thead>
        </table>
        </div>
        {orders.map((orderItems) => {
          return (
            <React.Fragment>
             <QueueRow orderItems={orderItems}/>
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
};

export default Orders;
